export default __webpack_public_path__ + "static/media/AndhraPradesh_2.0ccab087.png";